import api from './api';

export interface SaisonStatus {
  aktiv: boolean;
  saison: string | null;
  instanz: string | null;
}

export const saisonService = {
  getStatus: async (options?: { quiet?: boolean }): Promise<SaisonStatus> => {
    const response = await api.get<SaisonStatus>(
      '/saison',
      options?.quiet ? { skipErrorNotify: true } : undefined,
    );
    return response.data;
  },
  update: async (aktiv: boolean): Promise<SaisonStatus> => {
    const response = await api.put<SaisonStatus>('/saison', { aktiv });
    return response.data;
  },
};
